import {Component, EventEmitter, Output} from '@angular/core';
import {View} from './view';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent {

  @Output() currentView: EventEmitter<View> = new EventEmitter<View>();

  politicusI = false;
  politicusII = false;
  werknemerI = false;
  werknemerII = false;
  werknemerIII = false;
  werkgeverI = false;
  werkgeverII = false;
  historicusI = false;
  historicusII = false;
  intro = false;
  future = false;
  overview = true;

  showHistoricusI(): void {
    this.historicusI = true;
    this.overview = false;
    this.currentView.emit('historicusI');
  }

  showHistoricusII(): void {
    this.historicusII = true;
    this.overview = false;
    this.currentView.emit('historicusII');
  }

  showWerknemerI(): void {
    this.werknemerI = true;
    this.overview = false;
    this.currentView.emit('werknemerI');
  }

  showWerknemerII(): void {
    this.werknemerII = true;
    this.overview = false;
    this.currentView.emit('werknemerII');
  }

  showWerknemerIII(): void {
    this.werknemerIII = true;
    this.overview = false;
    this.currentView.emit('werknemerIII');
  }

  showWerkgeverI(): void {
    this.werkgeverI = true;
    this.overview = false;
    this.currentView.emit('werkgeverI');
  }

  showWerkgeverII(): void {
    this.werkgeverII = true;
    this.overview = false;
    this.currentView.emit('werkgeverII');
  }

  showPoliticusI(): void {
    this.politicusI = true;
    this.overview = false;
    this.currentView.emit('politicusI');
  }

  showPoliticusII(): void {
    this.politicusII = true;
    this.overview = false;
    this.currentView.emit('politicusII');
  }

  showInto(): void {
    this.intro = true;
    this.overview = false;
    this.currentView.emit('intro');
  }

  showFuture(): void {
    this.future = true;
    this.overview = false;
    this.currentView.emit('future');
  }

  hideModal(): void {
    this.closeAll();
    this.overview = true;
    this.currentView.emit('overview');
  }

  closeAll(): void {
    this.intro = false;
    this.future = false;
    this.politicusI = false;
    this.politicusII = false;
    this.werknemerI = false;
    this.werknemerII = false;
    this.werknemerIII = false;
    this.werkgeverI = false;
    this.werkgeverII = false;
    this.historicusI = false;
    this.historicusII = false;
  }

  openAndClose(open: View[], close: View[] = []): void {
    open.forEach(c => this.doFor(c, true));
    close.forEach(c => this.doFor(c, false));
  }

  private doFor(key: View, open: boolean): void {
    switch (key) {
      case 'intro':
        this.intro = open;
        break;
      case 'future':
        this.future = open;
        break;
      case 'politicusI':
        this.politicusI = open;
        break;
      case 'politicusII':
        this.politicusII = open;
        break;
      case 'werknemerI':
        this.werknemerI = open;
        break;
      case 'werknemerII':
        this.werknemerII = open;
        break;
      case 'werknemerIII':
        this.werknemerIII = open;
        break;
      case 'werkgeverI':
        this.werkgeverI = open;
        break;
      case 'werkgeverII':
        this.werkgeverII = open;
        break;
      case 'historicusI':
        this.historicusI = open;
        break;
      case 'historicusII':
        this.historicusII = open;
        break;
      default:
      // Intended fall-though
    }
  }
}
